import * as React from 'react'

// code - "us" or "us-al"
// alt - "USA" or "Alabama"
//
// https://flagpedia.net/us-states/alabama/download/api
const FlagImg = React.memo(({ lowercasedCode }) => {
  const lowercased = lowercasedCode.toLowerCase() // TODO
  return (
    <img
      loading='lazy'
      src={`https://flagcdn.com/20x15/${lowercased}.png`}
      srcSet={`https://flagcdn.com/40x30/${lowercased}.png 2x, https://flagcdn.com/60x45/${lowercased}.png 3x`}
      alt=''
    />
  )
})

export default FlagImg
